/** Abstract app config object. Provides information about current application environment configuration. */
export abstract class AppConfig {
  /** Stripe public key. */
  public abstract readonly stripePublicKey: string;

  /** S3 endpoint URL. */
  public abstract readonly s3Endpoint?: string;

  /** S3 region. */
  public abstract readonly s3Region: string;

  /** S3 bucket name. */
  public abstract readonly s3Bucket: string;

  /** API URL. */
  public abstract readonly apiUrl: string;
}
